/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconClockCheck = createReactComponent("outline", "clock-check", "IconClockCheck", [["path", { "d": "M20.942 13.021a9 9 0 1 0 -9.407 7.967", "key": "svg-0" }], ["path", { "d": "M12 7v5l3 3", "key": "svg-1" }], ["path", { "d": "M15 19l2 2l4 -4", "key": "svg-2" }]]);

export { IconClockCheck as default };
//# sourceMappingURL=IconClockCheck.mjs.map
